import {
    CLEAR_ERRORS,
    ALL_PRODUCT_REQUEST,
    ALL_PRODUCT_FAILURE,
    ALL_PRODUCT_SUCCESS,
    PRODUCT_DETAILS_REQUEST,
    PRODUCT_DETAILS_SUCCESS,
    PRODUCT_DETAILS_FAILURE,
    NEW_REVIEW_REQUEST,
    NEW_REVIEW_SUCCESS,
    NEW_REVIEW_FAILURE,
    NEW_REVIEW_RESET,
    ADMIN_PRODUCT_REQUEST,
    ADMIN_PRODUCT_FAILURE,
    ADMIN_PRODUCT_SUCCESS,
    NEW_PRODUCT_REQUEST,
    NEW_PRODUCT_SUCCESS,
    NEW_PRODUCT_FAILURE,
    NEW_PRODUCT_RESET,
    DELETE_PRODUCT_REQUEST,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAILURE,
    DELETE_PRODUCT_RESET,
    UPDATE_PRODUCT_REQUEST,
    UPDATE_PRODUCT_FAILURE,
    UPDATE_PRODUCT_SUCCESS,
    UPDATE_PRODUCT_RESET,
    ALL_REVIEW_REQUEST,
    ALL_REVIEW_SUCCESS,
    ALL_REVIEW_FAILURE,
    DELETE_REVIEW_REQUEST,
    DELETE_REVIEW_SUCCESS,
    DELETE_REVIEW_FAILURE,
    DELETE_REVIEW_RESET,
} from '../constants/productConstants';

export const productsReducer = (state = { products: [] }, { type, payload }) => {
    switch (type) {
        case ALL_PRODUCT_REQUEST:
        case ADMIN_PRODUCT_REQUEST:
            return { loading: true, products: [] };
        case ALL_PRODUCT_SUCCESS:
            return {
                loading: false,
                products: payload.products,
                productsCount: payload.productCount,
                resultPerPage: payload.resultPerPage,
                filteredProductsCount: payload.filteredProductsCount,
            };
        case ADMIN_PRODUCT_SUCCESS:
            return {
                loading: false,
                products: payload.products,
            };
        case ALL_PRODUCT_FAILURE:
        case ADMIN_PRODUCT_FAILURE:
            return { loading: false, error: payload };
        case CLEAR_ERRORS:
            return { ...state, error: null };
        default:
            return state;
    }
};

export const productDetailsReducer = (state = { product: null }, { type, payload }) => {
    switch (type) {
        case PRODUCT_DETAILS_REQUEST:
            return { ...state, loading: true };
        case PRODUCT_DETAILS_SUCCESS:
            return {
                loading: false,
                product: payload,
            };
        case PRODUCT_DETAILS_FAILURE:
            return { loading: false, error: payload };
        case CLEAR_ERRORS:
            return { ...state, error: null };
        default:
            return state;
    }
};

export const newReviewReducer = (state = {}, { type, payload }) => {
    switch (type) {
        case NEW_REVIEW_REQUEST:
            return { ...state, loading: true };
        case NEW_REVIEW_SUCCESS:
            return {
                loading: false,
                success: payload,
            };
        case NEW_REVIEW_FAILURE:
            return { ...state, loading: false, error: payload };
        case NEW_REVIEW_RESET:
            return { ...state, success: false };
        case CLEAR_ERRORS:
            return { ...state, error: null };
        default:
            return state;
    }
};

export const newProductReducer = (state = { product: {} }, { type, payload }) => {
    switch (type) {
        case NEW_PRODUCT_REQUEST:
            return { ...state, loading: true };
        case NEW_PRODUCT_SUCCESS:
            return {
                loading: false,
                success: payload.success,
                product: payload.product,
            };
        case NEW_PRODUCT_FAILURE:
            return { ...state, loading: false, error: payload };
        case NEW_PRODUCT_RESET:
            return { ...state, success: false };
        case CLEAR_ERRORS:
            return { ...state, error: null };
        default:
            return state;
    }
};

export const productReducer = (state = { product: {} }, { type, payload }) => {
    switch (type) {
        case DELETE_PRODUCT_REQUEST:
        case UPDATE_PRODUCT_REQUEST:
            return { ...state, loading: true };
        case DELETE_PRODUCT_SUCCESS:
            return {
                ...state,
                loading: false,
                isDeleted: payload,
            };
        case UPDATE_PRODUCT_SUCCESS:
            return {
                ...state,
                loading: false,
                isUpdated: payload,
            };
        case DELETE_PRODUCT_FAILURE:
        case UPDATE_PRODUCT_FAILURE:
            return { ...state, loading: false, error: payload };
        case DELETE_PRODUCT_RESET:
            return { ...state, isDeleted: false };
        case UPDATE_PRODUCT_RESET:
            return { ...state, isUpdated: false };
        case CLEAR_ERRORS:
            return { ...state, error: null };
        default:
            return state;
    }
};

export const productReviewsReducer = (state = { reviews: null }, { type, payload }) => {
    switch (type) {
        case ALL_REVIEW_REQUEST:
            return { ...state, loading: true };
        case ALL_REVIEW_SUCCESS:
            return {
                loading: false,
                reviews: payload,
            };
        case ALL_REVIEW_FAILURE:
            return { ...state, loading: false, error: payload };
        case CLEAR_ERRORS:
            return { ...state, error: null };
        default:
            return state;
    }
};

export const reviewReducer = (state = { product: {} }, { type, payload }) => {
    switch (type) {
        case DELETE_REVIEW_REQUEST:
            return { ...state, loading: true };
        case DELETE_REVIEW_SUCCESS:
            return {
                loading: false,
                isDeleted: payload,
            };
        case DELETE_REVIEW_FAILURE:
            return { ...state, loading: false, error: payload };
        case DELETE_REVIEW_RESET:
            return { ...state, isDeleted: false };
        case CLEAR_ERRORS:
            return { ...state, error: null };
        default:
            return state;
    }
};
